<template>
    <div class="diagram">
        <div class="content row-center" style="justify-content:flex-start">
            <div class="row-center">
                <el-date-picker :editable="false" :picker-options="pickerOptions" :clearable="false" class="dateSelect"
                    v-model="date" type="date" :placeholder="new Date().toLocaleDateString().replace(/\//g, '-')">
                </el-date-picker>
                <el-select style="width: 120px !important" class="node-select" v-model="node" placeholder="请选择">
                    <el-option v-for="i in options" :key="i.value" :value="i.value" :label="i.label">
                    </el-option>
                </el-select>
                <el-button class="btn per" plain @click="perD">上一日</el-button>
                <el-button class="btn next" plain @click="nextD" :disabled="nextDayDisabled">下一日
                </el-button>
            </div>
            <div class="row-center">
                <div class="max">
                    <el-checkbox label="最值分析" name="type" v-model="showMax">
                    </el-checkbox>
                </div>
            </div>
        </div>
        <Chart :showMax="showMax" :diagramData="diagramData" :canvasData="canvasData" :devicetype="devicetype"></Chart>
    </div>
</template>

<script>

import {
    harmonicAnalysis, LOOP_DIAGRAM_DATA_BY_DAY,getLoadCharts
} from "../../../api/power";
import { floatFormat } from "../../../util/MathUtil";
import { subscribe } from '../../../mqtt/index'
import Chart from "./Chart.vue";
import {
    dateFormat,
    dayEnd,
    dayStart,
    nextDay,
    nextMonth,
    nextYear,
    perDay,
    perMonth,
    perYear,
} from "../../../util/DateUtil";
export default {
    name: "Harmonic",
    components: {
        Chart
    },
    props: {
        currentLoop: Object,
        devicetype: Number
    },
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            date: new Date(),
            node: "1-2",
            showMax: true,
            diagramData: null,
            canvasData: false,
            dataunit: "A",
            options: [{
                value: '0-0',
                label: '功率因数'
            },
            {
                value: '0-1',
                label: '有功功率'
            },
            {
                value: '0-2',
                label: '无功功率'
            },
            {
                value: '0-3',
                label: '视在功率'
            },
            {
                value: '1-0',
                label: '三相相电压'
            },
            {
                value: '1-1',
                label: '三相线电压'
            },
            {
                value: '1-2',
                label: '三相电流'
            },
            {
                value: '2-0',
                label: '母排温度'
            },
            ],
        }
    },
    computed: {

        realData() {
            if (this.$store.state.project.projectInfo.projectId == '2') { //凯骏
                return [{
                    type: "功率",
                    details: [{
                        key: "功率因数",
                        unit: "",
                        data: {
                            A: "PFa",
                            B: "PFb",
                            C: "PFc",
                            总: "PF",
                        }
                    },
                    {
                        key: "有功功率",
                        unit: "kW",
                        // 这个属性，计算的时候会乘进去 0.001 就是除以1000
                        //multiple: 0.001,
                        multiple: 0.001,
                        data: {
                            A: "Pa",
                            B: "Pb",
                            C: "Pc",
                            总: "P",
                        }
                    },
                    {
                        key: "无功功率",
                        unit: "kVar",
                        multiple: 0.001,
                        data: {
                            A: "PRa",
                            B: "PRb",
                            C: "PRc",
                            总: "PR",
                        }
                    },
                    {
                        key: "视在功率",
                        unit: "kVA",
                        multiple: 0.001,
                        data: {
                            A: "PAa",
                            B: "PAb",
                            C: "PAc",
                            总: "PA",
                        }
                    },

                    ]
                },
                {
                    type: "电压、电流",
                    details: [{
                        key: "三相相电压",
                        unit: "V",
                        data: {
                            A: "Ua",
                            B: "Ub",
                            C: "Uc",
                        }
                    },
                    {
                        key: "三相线电压",
                        unit: "V",
                        data: {
                            A: "Uab",
                            B: "Ubc",
                            C: "Uac",
                        }
                    },
                    {
                        key: "三相电流",
                        unit: "A",
                        data: {
                            'A': "Ia",
                            'B': "Ib",
                            'C': "Ic",
                        }
                    },
                    ]
                },
                ]
            } else {
                if (this.$store.state.project.projectInfo.projectId == '6') {
                    return [
                        {
                            type: "功率",
                            details: [{
                                key: "功率因数",
                                unit: "",
                                data: {
                                    A: "PFa",
                                    B: "PFb",
                                    C: "PFc",
                                    总: "PF",
                                }
                            },
                            {
                                key: "有功功率",
                                unit: "kW",
                                // 这个属性，计算的时候会乘进去 0.001 就是除以1000
                                //multiple: 0.001,
                                multiple: 0.001,
                                data: {
                                    A: "Pa",
                                    B: "Pb",
                                    C: "Pc",
                                    总: "P",
                                }
                            },
                            {
                                key: "无功功率",
                                unit: "kVar",
                                multiple: 0.001,
                                data: {
                                    A: "PRa",
                                    B: "PRb",
                                    C: "PRc",
                                    总: "PR",
                                }
                            },
                            {
                                key: "视在功率",
                                unit: "kVA",
                                multiple: 0.001,
                                data: {
                                    A: "PAa",
                                    B: "PAb",
                                    C: "PAc",
                                    总: "PA",
                                }
                            },

                            ]
                        },
                        {
                            type: "电压、电流",
                            details: [{
                                key: "三相相电压",
                                unit: "V",
                                data: {
                                    A: "Ua",
                                    B: "Ub",
                                    C: "Uc",
                                }
                            },
                            {
                                key: "三相线电压",
                                unit: "V",
                                data: {
                                    A: "Uab",
                                    B: "Ubc",
                                    C: "Uac",
                                }
                            },
                            {
                                key: "三相电流",
                                unit: "A",
                                data: {
                                    'A': "Ia",
                                    'B': "Ib",
                                    'C': "Ic",
                                }
                            },
                            ]
                        },
                        // {
                        //     type: "温度",
                        //     details: [{
                        //             key: "母排温度",
                        //             unit: "℃",
                        //             data: {
                        //                 A: "Temperature_A",
                        //                 B: "Temperature_B",
                        //                 C: "Temperature_C"
                        //             }
                        //         }
                        //     ]
                        // },
                    ]

                } else {
                    return [{
                        type: "功率",
                        details: [{
                            key: "功率因数",
                            unit: "",
                            data: {
                                A: "PFa",
                                B: "PFb",
                                C: "PFc",
                                总: "PF",
                            }
                        },
                        {
                            key: "有功功率",
                            unit: "kW",
                            // 这个属性，计算的时候会乘进去 0.001 就是除以1000
                            //multiple: 0.001,
                            multiple: 0.001,
                            data: {
                                A: "Pa",
                                B: "Pb",
                                C: "Pc",
                                总: "P",
                            }
                        },
                        {
                            key: "无功功率",
                            unit: "kVar",
                            multiple: 0.001,
                            data: {
                                A: "PRa",
                                B: "PRb",
                                C: "PRc",
                                总: "PR",
                            }
                        },
                        {
                            key: "视在功率",
                            unit: "kVA",
                            multiple: 0.001,
                            data: {
                                A: "PAa",
                                B: "PAb",
                                C: "PAc",
                                总: "PA",
                            }
                        },

                        ]
                    },
                    {
                        type: "电压、电流",
                        details: [{
                            key: "三相相电压",
                            unit: "V",
                            data: {
                                A: "Ua",
                                B: "Ub",
                                C: "Uc",
                            }
                        },
                        {
                            key: "三相线电压",
                            unit: "V",
                            data: {
                                A: "Uab",
                                B: "Ubc",
                                C: "Uac",
                            }
                        },

                        {
                            key: "三相电流",
                            unit: "A",
                            data: {
                                'A': "Ia",
                                'B': "Ib",
                                'C': "Ic",
                            }
                        },
                        ]
                    },
                    {
                        type: "温度",
                        details: [{
                            key: "母排温度",
                            unit: "℃",
                            data: {
                                A: "Temperature_A",
                                B: "Temperature_B",
                                C: "Temperature_C"
                            }
                        }

                        ]
                    },
                    ]
                }
            }
        },
        mqttval() {
            return this.getMqttVal(this.$store.getters.mqttVal);
        },
        nextDayDisabled() {
            let timestamp = dateFormat("YY-mm-dd", new Date());
            let endtime = dateFormat("YY-mm-dd", this.date);
            if (this.radio === "year") {
                timestamp = dateFormat("YY", new Date());
                endtime = dateFormat("YY", this.date);
            } else if (this.radio === "month") {
                timestamp = dateFormat("YY-mm", new Date());
                endtime = dateFormat("YY-mm", this.date);
            }
            // console.log(endtime,timestamp)
            if (endtime >= timestamp) {
                return true;
            } else {
                return false;
            }
        },
        updataData() {
            return [
                this.node, this.currentLoop, this.date,this.showMax
            ]
        },
        //select选择的label
        selectLabel() {
            return this.options.filter((item) => item.value === this.node)[0].label;
        },
    },
    watch: {
        updataData() {
            this.canvasDataRult()
        }
    },
    mounted() {
        this.canvasDataRult()
    },
    methods: {
        canvasDataRult() {
            let strings = this.node.split("-");
            let data = this.realData[strings[0]].details[strings[1]].data;
            let unit = this.realData[strings[0]].details[strings[1]].unit;
            let multiple = this.realData[strings[0]].details[strings[1]].multiple
            let loopId = this.currentLoop.loopId;
            let promises = [];
            let legendTitle = [];
            let defaultlegendTitle = [];
            for (let key in data) {
                if (data.hasOwnProperty(key)) {
                    let node = data[key];
                    if (node) {
                        if (this.selectLabel == '三相电流') {
                            legendTitle.push(key + '相电流')
                        } else if (this.selectLabel == '三相相电压') {
                            legendTitle.push(key + '相相电压')
                        } else if (this.selectLabel == '三相线电压') {
                            legendTitle.push(key + '相线电压')
                        } else {
                            legendTitle.push(key === "总" ? key + this.selectLabel : key + '相' + this
                                .selectLabel)
                        }
                        defaultlegendTitle.push(key)
                        let start = dayStart(this.date)
                        let end = dayEnd(this.date)
                        let obj = {
                            deviceLoopId:loopId,
                            start:start,
                            end:end,
                            group:"5m",
                            node:node
                        }
                        promises.push(
                            // LOOP_DIAGRAM_DATA_BY_DAY(
                            //     loopId,
                            //     node,
                            //     this.date
                            // )
                            getLoadCharts(obj)
                        );
                    }
                }
            }

            Promise.all(promises).then((res) => {
                let pointsArray = []
                let map = res.map((r) => (r.data ? r.data.data.points : []));
                for (let key in data) {
                    if (data.hasOwnProperty(key)) {
                        let node = data[key];
                        map.forEach(item=>{
                            if(item[node]){
                                pointsArray.push(item[node])
                            }
                        })
                    }
                }
                let list = [];
                pointsArray.forEach((e) => {
                    list = list.concat(e);
                });
                if (list.length == 0) {
                    this.canvasData = true
                } else {
                    this.canvasData = false
                }

                let obj = {};
                let xAxisData = [];
                let seriesData = [];
                for (let index = 0; index < pointsArray[0].length; index++) {
                    const e = pointsArray[0][index];
                    if (e.val!='') {
                        xAxisData.push(e.time.split('T')[1].substr(0, 5));
                    }
                }
                pointsArray.forEach((e, i) => {
                    seriesData.push({
                        name: legendTitle[i],
                        data: e.map((p) => {
                            let v = p.val;
                            if(v!=""){
                                if (multiple) {
                                    v *= multiple
                                }
                                return Number(v).toFixed(2)
                            }else{
                                return ""
                            }
                            
                        }).filter(e=>e!='')
                    });
                });
                this.$set(
                    this,
                    "diagramData",
                    this.createCanvasData(legendTitle, xAxisData, seriesData, unit)
                );
            });
            return true;
        },

        createCanvasData(legendData, xAxisData, seriesData, unit) {
            let self = this
            self.dataunit = unit
            let series;
            let markPoint;
            if(this.showMax){
                markPoint = {
                    data: [
                        {
                            type: "max",
                            name: "最大值",
                        },
                        {
                            type: "min",
                            name: "最小值",
                        },
                    ],

                    symbol: "pin",
                    symbolSize: "20",
                    label: {
                        position: "top",
                    },
                }
            }
            series = seriesData.map((e) => {
                return {
                    smooth: true,
                    symbol:'none',
                    name: e.name,
                    step: 'start',
                    type: "line",
                    data: e.data,
                    connectNulls: true,
                    markPoint
                };
            });
            let color = ["#F6BD16", "#5AD8A6", "#E8684A", "#5D7092"];

            return {
                color,
                tooltip: {
                    trigger: "axis",
                    formatter: function (params) {
                        let str = `${params[0].name}<br/>`;
                        params.forEach((item, idx) => {
                            str += `${item.marker}${item.seriesName}： <b style='font-size:18px;'>${item.data}</b><b style='font-size:14px;'> ${self.dataunit}</b>`;
                            str += idx === params.length - 1 ? '' : '<br/>'
                        })
                        return str
                    }
                },
                legend: {
                    top: 0,
                    itemWidth: 10,
                    itemHeight: 10,
                    icon: "rect",
                    data: legendData,
                    textStyle: {
                        fontSize: "16rem"
                    },
                    itemGap: 20,
                    itemStyle: {

                    }
                },
                grid: {
                    left: "0%",
                    right: "3%",
                    top: "10%",
                    bottom: "5%",
                    containLabel: true
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: xAxisData,

                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: true
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#CCCCCC",
                            width: 1,
                            type: "solid",
                        },
                    },
                    axisLabel: {
                        //x轴文字的配置
                        show: true,
                        textStyle: {
                            color: "#999999",
                        },
                    },
                },

                // title: {
                //     text: self.dataunit,
                //     left: -5,// 距离左边位置
                //     top: -5,// 距离上面位置
                //     textStyle:{
                //         fontWeight:'bold',
                //         fontSize:12,
                //         fontStyle:'italic'
                //     }
                // },
                yAxis: {
                    nameTextStyle: {
                        color: "#999999",
                        // fontSize: "14",
                    },
                    name: self.dataunit,
                    boundaryGap: true,
                    axisTick: {
                        show: false,
                    },
                    show: true,
                    spiltLine: {
                        show: true
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#CCCCCC",
                            width: 1,
                            type: "solid",
                        },
                    },
                    axisLabel: {
                        //x轴文字的配置
                        show: true,
                        textStyle: {
                            color: "#999999",
                        },
                    },
                    type: "value",
                },
                series,
            };
        },
        getMqttVal(f) {
            return (k, m) => {
                if (k) {

                    let mqttVal = f(k);
                    if (m) {
                        mqttVal *= m;
                    }

                    mqttVal = floatFormat(mqttVal, 2);

                    // console.log(typeof mqttVal)

                    if (typeof mqttVal === "object") {
                        return mqttVal;
                    }

                    return mqttVal !== undefined && !isNaN(mqttVal) ? mqttVal : "--";
                } else {
                    return "--";
                }
            };
        },
        perD() {
            this.date = perDay(this.date);
        },
        nextD() {
            this.date = nextDay(this.date);
        },
    },
};
</script>

<style lang="less" scoped>
.diagram {
     // .h(518);


     .tab {
         width: 100%;
         .h(438);
         margin-top: 25rem;
     }

     .content {
         // margin-top: 10rem;
         border-bottom: 1px solid rgba(0, 0, 0, 0.15);
         padding-bottom: 10rem;

         .dateSelect {
             font-size: 18rem;
             color: #000000 !important;
             margin-right: 8rem;
         }

         .node-select {
             margin-right: 8rem;
         }

         .max {
             .w(100);
             margin-left: 27rem;
         }

         .hose {
             display: flex;
             align-items: center;
         }
     }

 }
</style>